<div class="root noselect">
  <div>
    <header>
      <h1>Configuração de Pedidos</h1>
    </header>

    <section>
      <form [formGroup]="formNotificacao">
        <div class="field">
          <span>Modo de confirmação dos pedidos:</span>
          <mat-select
            placeholder="Manual"
            [(value)]="kanbanService.modoConfirmacaoPedido"
          >
            <mat-option value="M" selected>Manual</mat-option>
            <mat-option value="A">Automático</mat-option>
          </mat-select>
        </div>

        <div class="field">
          <span
            >Não exibir pedidos Finalizados/Cancelados feitos a mais de:</span
          >
          <mat-select
            placeholder="1 hora"
            formControlName="tempoPermanenciaNoMonitor"
          >
            <mat-option value="1" selected>1 hora</mat-option>
            <mat-option value="2" selected>2 horas</mat-option>
            <mat-option value="3" selected>3 horas</mat-option>
            <mat-option value="6" selected>6 horas</mat-option>
            <mat-option value="12" selected>12 horas</mat-option>
            <mat-option value="24" selected>24 horas</mat-option>
            <mat-option value="36" selected>24 horas</mat-option>
            <mat-option value="48" selected>24 horas</mat-option>
          </mat-select>
        </div>

        <hr />

        <div class="field">
          <span>Emitir alerta enquanto tiver pedido pendente:</span>
          <mat-select
            placeholder="Manualmente"
            formControlName="repetirSomPedidoPendente"
          >
            <mat-option value="LIGADO" selected>Ligado</mat-option>
            <mat-option value="DESLIGADO">Desligado</mat-option>
          </mat-select>
        </div>

        <div class="field">
          <span>Emitir alertar a cada período de:</span>
          <mat-select
            placeholder="5 minutos"
            formControlName="repetirSomPedidoPendentePeriodo"
          >
            <mat-option value="60" selected>1 minuto</mat-option>
            <mat-option value="120">2 minutos</mat-option>
            <mat-option value="300">5 minutos</mat-option>
            <mat-option value="600">10 minutos</mat-option>
            <mat-option value="900">15 minutos</mat-option>
            <mat-option value="1200">20 minutos</mat-option>
            <mat-option value="1800">30 minutos</mat-option>
          </mat-select>
        </div>

        <hr />

        <div class="field">
          <span>Notificação a tocar quando receber pedido:</span>
          <mat-select placeholder="default" formControlName="notificacao">
            <mat-option value="default" selected>Padrão</mat-option>
            <mat-option value="nenhum" selected>Não tocar som</mat-option>
            <mat-option value="sound_1" selected>Som 01</mat-option>
            <mat-option value="sound_2" selected>Som 02</mat-option>
            <mat-option value="sound_3" selected>Som 03</mat-option>
            <mat-option value="sound_4" selected>Som 04</mat-option>
            <mat-option value="sound_5" selected>Som 05</mat-option>
            <mat-option value="sound_6" selected>Som 06</mat-option>
            <mat-option value="sound_7" selected>Som 07</mat-option>
            <mat-option value="sound_8" selected>Som 08</mat-option>
          </mat-select>
        </div>

        <div class="field">
          <span>Repetir o som quantas vezes:</span>
          <mat-select placeholder="1 vez" formControlName="numeroRepeticoes">
            <mat-option value="1" selected>1 vez</mat-option>
            <mat-option value="2">2 vezes</mat-option>
            <mat-option value="3">3 vezes</mat-option>
            <mat-option value="4">4 vezes</mat-option>
            <mat-option value="5">5 vezes</mat-option>
          </mat-select>
        </div>

        <div class="field">
          <span
            >Volume:
            <span div="display-volume" class="config-value"
              >{{ formNotificacao.get("volume").value }}%</span
            ></span
          >
          <mat-slider
            showTickMarks
            discrete
            formControlName="volume"
            class="example-margin"
            max="100"
            min="5"
            step="1"
          >
          </mat-slider>
        </div>
      </form>
    </section>

    <footer>
      <a id="btn-testar-som" mat-flat-button (click)="testarSom()">
        Testar Som
      </a>
    </footer>
  </div>

  <div>
    <header>
      <h1>Configuração de Impressão</h1>
    </header>

    <section>
      <form [formGroup]="form">
        <div class="field">
          <span>Imprimir:</span>
          <mat-select
            placeholder="Manualmente"
            formControlName="disparoImpressao"
          >
            <mat-option value="MANUAL" selected>Manualmente</mat-option>
            <mat-option value="AUTOMATICO"
              >Automaticamente ao confirmar o pedido</mat-option
            >
          </mat-select>
        </div>

        <div class="field">
          <span>Impressora:</span>
          <mat-select placeholder="(Selecionar)" formControlName="impressora">
            <mat-option value="" selected>(Selecionar)</mat-option>
            <mat-option
              *ngFor="let impressora of impressaoService.listaImpressoras"
              [value]="impressora"
              selected
              >{{ impressora }}</mat-option
            >
          </mat-select>
        </div>

        <div class="field">
          <span>Número de cópias:</span>
          <mat-select placeholder="1" formControlName="numeroCopias">
            <mat-option value="1" selected>1</mat-option>
            <mat-option value="2" selected>2</mat-option>
            <mat-option value="3" selected>3</mat-option>
            <mat-option value="4" selected>4</mat-option>
            <mat-option value="5" selected>5</mat-option>
          </mat-select>
        </div>

        <div class="field">
          <span>Número colunas papel:</span>
          <mat-select placeholder="40" formControlName="numeroColunas">
            <mat-option value="48" selected>48</mat-option>
            <mat-option value="40" selected>40</mat-option>
            <mat-option value="42" selected>42</mat-option>
            <mat-option value="32" selected>32</mat-option>
          </mat-select>
        </div>

        <div class="field">
          <span>Avançar papel no final da impressão:</span>
          <mat-select placeholder="2x" formControlName="avancoPapelFinal">
            <mat-option value="1" selected>1 vez</mat-option>
            <mat-option value="2" selected>2 vezes</mat-option>
            <mat-option value="3" selected>3 vezes</mat-option>
            <mat-option value="4" selected>4 vezes</mat-option>
            <mat-option value="5" selected>5 vezes</mat-option>
            <mat-option value="6" selected>6 vezes</mat-option>
            <mat-option value="7" selected>7 vezes</mat-option>
            <mat-option value="8" selected>8 vezes</mat-option>
            <mat-option value="9" selected>9 vezes</mat-option>
            <mat-option value="10" selected>10 vezes</mat-option>
          </mat-select>
        </div>
      </form>

      <div class="field">
        <span>Carregar Certificado Digital QZ Tray:</span>
        <input
          color="#fff"
          type="file"
          multiple
          (change)="onLoadCertificados($event.target.files)"
        />
      </div>

      <p class="list-certificate">
        <span *ngIf="this.impressaoService.temCertificado"
          >Certificate: <strong>OK</strong></span
        >
        <span
          *ngIf="
            this.impressaoService.temCertificado &&
            this.impressaoService.temChavePrivada
          "
          class="divider"
          >|</span
        >
        <span *ngIf="this.impressaoService.temChavePrivada"
          >Private-key: <strong>OK</strong></span
        >
      </p>
    </section>

    <footer>
      <a mat-flat-button (click)="testar()" title="Testar Impressão">
        <mat-icon>printer</mat-icon>
      </a>

      <a id="salvar" mat-flat-button (click)="salvarConfiguracao()"> Salvar </a>
    </footer>
  </div>
</div>
